import { render, staticRenderFns } from "./NoContent204Error.vue?vue&type=template&id=ef2b374e&"
import script from "./NoContent204Error.vue?vue&type=script&lang=js&"
export * from "./NoContent204Error.vue?vue&type=script&lang=js&"
import style0 from "./NoContent204Error.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports